<template>
  <div class="clubs">
    <el-table
      :data="clubs"
      style="width: 100%"
      empty-text="No clubs"
    >

      <el-table-column
        prop="name"
        label="Club Name"
        header-align="center"
      />

      <el-table-column
        prop="primary_contact_name"
        label="Primary Contact Name"
        header-align="center"
      />

      <el-table-column
        prop="primary_contact_number"
        label="Primary Contact Number"
        header-align="center"
      />

      <el-table-column
        prop="booking_count"
        label="Booking Count"
        header-align="center"
      />

      <el-table-column
        v-if="userIsSuperAdmin"
        prop="client_id"
        label="Client"
        header-align="center"
        :formatter="humaniseClient"
      />

      <el-table-column
        label="Operations"
        align="center"
      >
        <template slot-scope="props">
          <operations
            :id="props.row.id"
            :disableMore="true"
            @edit="editClub(props.row)"
            @delete="deleteClub(props.row)"
          />
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import auth from "../../auth";
import requests from "../../requests";

import operations from "../admin/OpButtons.vue";

export default {
  name: "club-table",
  data() {
    return {
      clubs: [],
      clients: [],
      userIsSuperAdmin: false
    };
  },
  beforeMount() {
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = profile.role === 3;

    this.getClubs();
  },
  methods: {
    getClubs() {
      this.clubs = [];

      if (this.userIsSuperAdmin) {
        requests.getAllClubs(this, clubResult => {
          if (clubResult.action === "success") {
            this.clubs = clubResult.data;

            requests.getAllClients(this, clientResult => {
              if (clientResult.action === "success") {
                this.clients = clientResult.data;
              }
            });
          }
        });
      } else {
        requests.getClubs(this, result => {
          this.clubs = result.data;
        });
      }
    },
    editClub(clubData) {
      this.$emit("editClub", clubData);
    },
    deleteClub(row) {
      this.$emit("deleteClub", row);
    },
    humaniseClient(row) {
      if (!this.clients.length) return row.client_id
      return this.clients.find(client => client.id === row.client_id).name || row.client_id
    }
  },
  components: {
    operations: operations
  }
};
</script>

<style>
.el-table .cell {
  word-break: normal !important;
}
</style>




// WEBPACK FOOTER //
// ClubTable.vue?706a7caa